import React, { Component } from 'react'
import Modal from 'react-modal'
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils'
import TdsStatusUpdateModalUI from './TdsStatusUpdateModalUI.js'

class TdsStatusUpdateModalSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      successMsg: null,
      errorList: [],
      submitted: false
    }
  }

  render() {
    return (
      <TdsStatusUpdateModalUI
        context={this.props.context}
        successMsg={this.state.successMsg}
        errorList={this.state.errorList}
        setErrorList={this.setErrorList}
        updateMode={this.props.updateMode}
        submitted={this.state.submitted}
        onSubmit={this.onSubmit}
        onCancelClick={this.props.onCancelClick}
        account={this.props.account}
      />
    )
  }

  componentDidMount() {
    Modal.setAppElement('body')
  }

  componentDidUpdate(prevProps) {
    if (this.props.updateMode && !prevProps.updateMode) {
      this.setState({
        successMsg: null,
        errorList: [],
        submitted: false
      })
    }
  }

  onSubmit = () => {
    if (this.state.submitted || !this.props.account) {
      return
    }

    const accountId = this.props.account.accountId
    const tdsStatus = !this.props.account.tdsStatus

    this.setState({
      successMsg: null,
      errorList: [],
      submitted: true
    })

    RestApiUtils.put(
      this.props.context,
      `/api/su/accounts/${accountId}/tdsStatus`,
      (response) => this.onSubmitCallback(response, accountId, tdsStatus),
      { tdsStatus: tdsStatus }
    )
  }

  onSubmitCallback = (response, accountId, tdsStatus) => {
    const responseErrorList = response && Array.isArray(response.errorList) ? response.errorList : []
    let errorList = responseErrorList.map(error => error && error.message ? error.message : error)
    const hasSuccess = !!(response && response.success)
    const isSuccessful = responseErrorList.length === 0 && hasSuccess

    if (!isSuccessful && errorList.length === 0) {
      errorList = ['Unable to update TDS status. Please try again.']
    }

    this.setState({
      successMsg: response ? response.success : null,
      errorList: errorList,
      submitted: false
    })

    if (isSuccessful) {
      setTimeout(() => {
        this.setState({ successMsg: null })
        if (this.props.onTdsStatusUpdated) {
          this.props.onTdsStatusUpdated(accountId, tdsStatus)
        }
        this.props.onCancelClick()
      }, 20)
    }
  }

  setErrorList = (errorList) => {
    this.setState({ errorList: errorList })
  }
}

export default TdsStatusUpdateModalSF
